import { Button, Checkbox, Col, Form, Input, InputNumber, Row, Select, Tabs, Tooltip } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { RxUpdate } from 'react-icons/rx';
import EventEmitter from '../../utils/eventEmitter';
import useDeliveryRegionAPI from '../apis/deliveryRegionAPI';



const DeliveryRegionChanges = () => {
  const { deliveryRegion, products } = useLoaderData();
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState(deliveryRegion.name ? deliveryRegion.name : '');
  const { create, update } = useDeliveryRegionAPI();
  

  const onChangeName = e => setName(e.target.value);

  const handleSave = () => { 
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    create(data, success);
    console.log(data);
  };

  const edit = () => { 
    // let data = form.getFieldsValue();
    // data['name'] = name;
    // data['seo'] = name.toLowerCase().replace(/ /g, '-');
    // data['id'] = deliveryRegion.id;
    // update(deliveryRegion.seo, data, success);
    // console.log(data)
  };

  const handleDiscard = () => { };

  useEffect(() => {
    EventEmitter.subscribe('delivery_response', data => {
      navigate('/pos/delivery-regions/'+data);
    });

    return () => {
      EventEmitter.unsubscribe('delivery_response');
    }
  },[])


  return (
    <div className='container mx-auto' style={{ maxWidth: '900px' }}>
      <div className='flex justify-between'>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/pos/delivery-regions'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Delivery Regions</Link> / {params.action}
          </h3>
          <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={handleSave} type='text' htmlType='button'
              disabled={ deliveryRegion.seo ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          {/* <Tooltip  title='edit' placement='rightBottom' className='ms-1'>
            <Button onClick={handleDiscard} type='text' htmlType='button'
              // disabled={ formValue.status === 'draft' ? false : true}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<MdEdit />}
            />
          </Tooltip> */}
        </div>
        {deliveryRegion.seo && <Button htmlType='button' onClick={edit} icon={<RxUpdate />}>UPDATE</Button>}
      </div>
      <div className='mt-5 p-3 bg-white shadow p-3'>
        <FloatingLabel
          className='text-2xl'
          variant="standard"
          // disabled={formValue.status!== 'discard' ? true : false}
          label="Delivery Region Name"
          value={name} 
          onChange={onChangeName}
        />
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{ span: 7 }}
          labelWrap={true}
          initialValues={deliveryRegion.seo ? deliveryRegion : {}}
          // disabled={formValue.status!== 'discard' ? true : false}
          autoComplete="off"
          variant='borderless'
        >
          <Row>
            <Col md={{span: 11}}>
            <Form.Item labelCol={{md: {span: 10}}} label='Delivery Charge' name='delivery_charge' className='font-semibold text-gray-800 mb-4' >
                <InputNumber className='input-outline-none'/>
              </Form.Item>
              <Form.Item labelCol={{md: {span: 10}}} label='Delivery Product' name='product_id' className='font-semibold text-gray-800 mb-4' >
                <Select options={products.map(product => ({value: product.id, label: product.name}))}/>
              </Form.Item>
            </Col>
          </Row>
          
        </Form>
      </div>
    </div>
  )
}

export default DeliveryRegionChanges;